import REGISTER from "../assets/images/register.png";
import Checkbox from "antd/es/checkbox/Checkbox";
import {NavLink, useHistory} from "react-router-dom";
import {useState} from "react";
import $ from 'jquery';
import toast from "../utils/swalToast";
import {Eye, EyeOff} from "react-feather";

export default function Register() {
    const [type, setType] = useState('candidate');
    const [isVisible, setIsVisible] = useState(false)
    const history = useHistory();
    const onCheckboxChange = (e) => {
        console.log(`checked = ${e.target.checked}`);
    };

    function submitHandle(event) {
        event.preventDefault();
        event.stopPropagation();
        // Registration logic commented out
    }

    return (
        <>
            <div className='auth-container'>
                <div className="auth-image" data-aos='fade-right'>
                    <img src={REGISTER} loading={"lazy"} alt="Login Image"/>
                </div>
                <div className="auth-form" data-aos='fade-left'>
                    <h4 className="title">Welcome to ShiptIt.</h4>
                    <form noValidate className='RegisterForm' onSubmit={submitHandle}>
                        <div className="register-form">
                            <div className="form-group">
                                <label>Full Name <code>*</code></label>
                                <input type="text" required placeholder={'Enter Full Name'}
                                       name={'name'}/>
                            </div>
                            <div className="form-group">
                                <label>Company Name <code>*</code></label>
                                <input type="text" required placeholder={'Enter Company Name'}
                                       name={'company'}/>
                            </div>
                            <div className="form-group">
                                <label>Phone Number <code>*</code></label>
                                <input type="number" required placeholder={'Enter Phone No.'}
                                       name={'phone'}/>
                            </div>
                            <div className="form-group">
                                <label>Email address <code>*</code></label>
                                <input type="text" required placeholder={'Email Address'} name={'email'}/>
                            </div>
                            <div className="form-group">
                                <label>UserName <code>*</code></label>
                                <input type="text" required placeholder={'Enter UserName'}
                                       name={'username'}/>
                            </div>
                            <div className="form-group">
                                <label>Password <code>*</code></label>
                                <input type={isVisible ? "text" : "password"} required placeholder={'Password'}
                                       name={'password'}/>
                                <button type={"button"} onClick={() => setIsVisible(!isVisible)} className='btn_eye'>
                                    {
                                        isVisible ?
                                            <EyeOff/> :
                                            <Eye/>
                                    }
                                </button>
                            </div>
                            <div className="form-group">
                                <label>Confirm Password <code>*</code></label>
                                <input type={isVisible ? "text" : "password"} required placeholder={'Password'}
                                       name={'cpassword'}/>
                                <button type={"button"} onClick={() => setIsVisible(!isVisible)} className='btn_eye'>
                                    {
                                        isVisible ?
                                            <EyeOff/> :
                                            <Eye/>
                                    }
                                </button>

                            </div>
                        </div>
                        <div className="form-group space-between-content">
                            <Checkbox onChange={onCheckboxChange}>I agree to accept terms and conditions
                                and
                                Privacy
                                Policy.</Checkbox>
                        </div>
                        <div className="form-group">
                            <button type={"submit"} className='btn-login'>Register</button>
                        </div>
                        <div className="form-group">
                            <div className="row-item">
                                <span>Already have an account? </span><NavLink to={'/auth/login'}>Login</NavLink>
                            </div>
                        </div>
                    </form>

                </div>
            </div>
        </>
    )
}

